import { Controller } from "@hotwired/stimulus"
import { usesSidebarLayout } from "../utils/layout_media"

// The named header entry preserves the page's contextual chat when it belongs
// to this persona; elsewhere it opens the selected persona's existing thread.
export default class extends Controller {
    static values = { personaId: Number, chatUrl: String, newChatUrl: String, name: String }
    static targets = ["status"]

    async toggle(event) {
        event.preventDefault()
        const sidebar = document.querySelector('[data-controller~="jane-sidebar"]')
        if (sidebar && usesSidebarLayout() && Number(sidebar.dataset.janeSidebarPersonaIdValue || 0) === this.personaIdValue) {
            document.dispatchEvent(new CustomEvent("jane-sidebar:toggle"))
            return
        }
        // Preserve custom page sidebar toggles that still use this controller.
        if (!this.hasChatUrlValue) {
            document.dispatchEvent(new CustomEvent("jane-sidebar:toggle"))
            return
        }
        await this._open(false)
    }

    async call(event) {
        event.preventDefault()
        await this._open(true)
    }

    async newChat(event) {
        event.preventDefault()
        await this._open(false, true)
    }

    async _open(voice, fresh = false) {
        if (this.loading) return
        this.loading = true
        try {
            if (fresh) {
                const created = await fetch(this.newChatUrlValue, {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content || ""
                    },
                    credentials: "same-origin",
                    body: new URLSearchParams({ persona_id: this.personaIdValue, purpose: "chat" })
                })
                if (!created.ok) throw new Error("Conversation unavailable")
            }
            const response = await fetch(this.chatUrlValue, { headers: { Accept: "application/json" }, credentials: "same-origin" })
            if (!response.ok) throw new Error("Conversation unavailable")
            const thread = await response.json()
            if (voice) {
                if (!thread.conversation_id) throw new Error("Conversation unavailable")
                window.dispatchEvent(new CustomEvent("assistant-voice:open", { detail: {
                    conversationId: String(thread.conversation_id), name: thread.assistant_name, avatar: thread.assistant_avatar
                } }))
            } else {
                window.dispatchEvent(new CustomEvent("jane:compose", { detail: {
                    url: thread.thread_url, title: thread.assistant_name, avatar: thread.assistant_avatar
                } }))
            }
            if (this.hasStatusTarget) this.statusTarget.textContent = ""
        } catch (_error) {
            if (this.hasStatusTarget) this.statusTarget.textContent = "Couldn't open this conversation. Try again."
        } finally {
            this.loading = false
        }
    }
}
